import ribbonIcon from "../../assets/icons/ribbon.png";
import { getPoiAsset } from "../../helpers";
import { useStores } from "../../use.store";

const CardPoi = ({ onClickCard, data }) => {
  const { mainStore, mapStore } = useStores();

  return (
    <div className="relative w-[110px]" onClick={onClickCard}>
      <img
        src={ribbonIcon}
        className="w-[22px] h-[10px] left-1/2 -translate-x-1/2 absolute top-[-10px]"
      />
      <div className="flex text-white w-[22px] h-[22px] left-1/2 -translate-x-1/2 absolute top-0 bg-[#A09200] items-center justify-center" />
      <div className="flex flex-col rounded rounded-b-md rounded-t-3xl border border-[#7A9A01] w-[110px]">
        <img
          src={getPoiAsset(mainStore.config, data)}
          className="w-full h-[70px] object-cover object-center rounded-t-3xl"
        />
        <div className="flex flex-col w-full h-[120px] rounded rounded-3xl py-1.5 px-3 h-[70px]">
          <span className="text-xs">{data.name}</span>
        </div>
        <div class="flex flex-row bg-[#A89200] h-[26px] w-full items-center justify-center text-white rounded-b-md">
          <span className=" text-[10px]">More Details</span>
        </div>
      </div>
    </div>
  );
};

export default CardPoi;
